import React from "react";
import { toAbsoluteUrl } from "../../../_helpers";
import moment from "moment-timezone";
import AdvancedTag from "../../popup/AdvancedTag";
import Availability from "../../popup/Availability";
import CertificateLink from "../../popup/CertificateLink";
import { CopyUrlAlert } from '../../widgets/tiles/CopyURLAlert';
import DiamondTypeTag from "../../popup/DiamondTypeTag";

export const HoldListColumn = (userinfo,ConfirmHold,CancelHold) => [
    {
        Header: "Action",
        // id: "Action",
        className: "text-center align-middle Action",
        filterType: 'select',
        accessor: "orderStatus",
        Cell: ({ row }) => {
            const actionConfig = {
                "Approved": { 
                  className: "label-outline-success bg-success-o-20", 
                  displayText: "Approved" 
                },
                "Released": { 
                  className: "label-outline-danger bg-danger-o-20", 
                  displayText: "Released" 
                },
                "Declined": { 
                  className: "label-outline-danger bg-danger-o-20", 
                  displayText: "Declined" 
                },
                "Hold Release": { 
                  className: "label-outline-danger bg-danger-o-20", 
                  displayText: "Hold Release" 
                },
                "Action": {
                  isButtonGroup: true,
                  buttons: [
                    { 
                      text: "Approve", 
                      className: "btn-xs btn-primary",
                      onClick: (row) => ConfirmHold(row) 
                    },
                    { 
                      text: "Decline", 
                      className: "btn-xs btn-danger",
                      onClick: (row) => CancelHold(row) 
                    }
                  ]
                }
              };
              const status = row.original.orderStatus;
              const config = actionConfig[status] || { displayText: "-" };
              
              if (config.isButtonGroup && (userinfo.editPerm || !userinfo.subId )) {
                return (
                  <div className="btn-group btn-group-sm" role="group">
                    {config.buttons.map((button, index) => (
                      <button
                        key={index}
                        type="button"
                        className={`btn ${button.className}`}
                        onClick={() => button.onClick(row)}
                      >
                        {button.text}
                      </button>
                    ))}
                  </div>
                );
              }
              else if(config.isButtonGroup){
                return (<span>-</span>)
              }
              
              return (
                <span className={`label label-pill label-inline font-weight-bold text-nowrap ${config.className || ''}`}>
                  {config.displayText}
                </span>
              );
        },
    },
    {
        Header: "Order ID",
        accessor: "confirmGoodsId",
        className: "text-center align-middle",
    },
    {
        Header: "Order Type",
        filterType: 'select',
        accessor: "orderType",
        Cell: (d) => (
            <>
                <span className="font-weight-bolder text-primary">
                    {d.value === "Hold Request"?
                    <span className="label label-light-warning label-pill label-inline font-weight-bold text-nowrap">Hold Request</span>:
                    <span className="label label-light-success label-pill label-inline font-weight-bold text-nowrap">Buy Request</span>}
                </span>
            </>
        ),
        className: "text-center align-middle",
    },
    {
        Header: "Diamond Detail",
        accessor: (d) => (
            <>
            {d.diamondType === "PN" || d.diamondType === "PL" ? 
                <div className="row">
                    <div className="col-2 text-center p-0">
                        <img
                            className="img-fluid mr-2"
                            alt={d.cShape}
                            src={toAbsoluteUrl(`/media/shape/svg_shape/parcel/${d.cShape.toLowerCase()}.svg`)}
                            width="50px"
                            onError={e => {
                                e.currentTarget.src = toAbsoluteUrl(
                                    `/media/shape/svg_shape/parcel/other.svg`
                                    )
                                }}
                        />
                    </div>
                    <div className="col-10 pl-2 p-0 text-left">
                        <div className={`mb-1 ${d.diamondType === "PN" ? "natTab" : "labTab"}`}>
                        <DiamondTypeTag diamondTypeTagColor={d.diamondTypeTagColor} diamondTypeTag={d.diamondTypeTag}/>
                            <span className={`text-primary small ml-3`}>
                                {d.diamondType}-{d.parcelId}-{d.splitId}{d.cgSplitId ?<>/{d.cgSplitId}</> : ""}
                            </span>
                            <span className={`text-primary text-capitalize small ml-3`}>
                                {d.lengthMm} - {d.widthMm} MM
                            </span>
                        </div>

                        <span className="text-dark font-weight-bold d-block">
                            {d.cShape}{" "}
                            {(d.cWeight).toFixed(2)}Ct.{" "}
                            {d.cColor}{" "}
                            {d.cClarity}{" "}{d.cCut}{" "}{d.cPolish}{" "}{d.cSymmetry}{" "}
                            {d.cFluorescence}
                        </span>
                    </div>
                </div>
             :
                <div className="row">
                    <div className="col-2 text-center p-0">
                        {d.image &&  d.image !=="null" ? (
                            <img
                                className="img-fluid mr-2"
                                alt={d.cShape}
                                src={d.image}
                                width="50px"
                                onError={e => toAbsoluteUrl(
                                    e.currentTarget.src = `/media/shape/${d.cShape ? d.cShape.toLowerCase() : ""}-no.png`
                                )}
                            />
                        ) : (
                            <img
                                className="img-fluid mr-2"
                                alt={d.cShape}
                                src={toAbsoluteUrl(
                                    `/media/shape/${d.cShape ? d.cShape.toLowerCase() : ""}-no.png`
                                )}
                                onError={e => {
                                    e.currentTarget.src = toAbsoluteUrl(
                                        `/media/General/NoDiamondImage.svg`
                                    )
                                }}
                                width="50px"
                                style={{ backgroundColor: "#f4f4f4" }}
                            />
                        )}
                    </div>
                    <div className="col-10 pl-2 p-0 text-left">
                        <div className={`mb-1 ${d.diamondType === "W" || d.diamondType === "N" ? "natTab" : "labTab"}`}>
                            <Availability  availability={d.availability}/>
                            <DiamondTypeTag diamondTypeTagColor={d.diamondTypeTagColor} diamondTypeTag={d.diamondTypeTag}/>
                            <span  className={`text-primary small ml-3`}>
                                {d.loatNO}
                            </span>
                                {d.certiNo ? (
                                    <>

                                        <CertificateLink Certificate_link={d.certificate_link} lab={d.lab} certificate={d.certiNo} withExternalLinkIcon className={`text-primary mx-2 small`} />
                                        {d.lab !== "NON" && <CopyUrlAlert text={d.certiNo} />}
                                    </>

                                ) : (
                                    ""
                                )}
                        </div>

                        <span className="text-dark font-weight-bold d-block">
                            {d.cShape}{" "}
                            {(d.cWeight).toFixed(2)}Ct.{" "}
                            {d.cColor === "fancy" ? (
                                <>
                                    {d.fIntensity}{" "}{d.fOvertone}{" "}{d.fColor}{" "}
                                </>
                            ) : (
                                <>{d.cColor}{" "}</>
                            )}
                            {d.cClarity}{" "}{d.cCut}{" "}{d.cPolish}{" "}{d.cSymmetry}{" "}
                            {d.cFluorescence}
                        </span>
                    </div>
                </div> 
                }
            </>
        ),
        className: "text-center align-middle text-nowrap",
    },  
    {
        Header: "Advanced tags",
        accessor: (d) => (
            <>
                <AdvancedTag {...d}/>
            </>
        ),
        className: "text-center align-middle",
    },
    {
        Header: "Price",
        className: "text-right  text-nowrap align-middle pr-5",
        accessor: (d) => (
            <>
                <span className="font-weight-bolder text-primary">
                    ${parseFloat(d.oRate * d.cWeight).toFixed(2)}
                </span>{" "}
                <br />
                <span className="text-muted small">
                    $/CT ${parseFloat(d.oRate).toFixed(2)}
                </span>
            </>
        ),
        sortMethod: (a, b) => Number(a) - Number(b),
       
    },
    {
        Header: "Date & Time",
        // accessor: "cd",
        accessor: (d) => {
            return (
                d.createdDate ? <>
                    {d.createdDate}
                </> : "-"
            );
        },
        className: "text-center align-middle text-nowrap",
    },
    
];
